
import {
	Box,
	Typography
} from "@mui/material";
import { StudentResultStyle } from "@styles/student-portal/StudentResultStyle";
import useEmotionStyles from "@styles/shared/useEmotionStyles";

import React from "react";
import { TextViewer } from "@components/common";

import { useStores } from "@hooks/useStores";
import { IQuestionInfo } from "@repositories/model/transfer/IQuestionInfo";
import { useCurrentQuestionHTML } from "@views/shared/functions/useCurrentQuestionHTML";

type Props = {
	idx: number;
	questionInfo: IQuestionInfo;
	examOrderAndQuestionsLengthMap: any;
}

export const QuestionRow = (props: Props) => {
	const { idx, questionInfo, examOrderAndQuestionsLengthMap } = props;
	const { projectExamStore } = useStores();
	const classes = useEmotionStyles(StudentResultStyle, { isFirst: idx === 0 });

	const currentOrder = React.useMemo(() => {
		const questionListLen = examOrderAndQuestionsLengthMap[questionInfo.parentOrder];

		return projectExamStore.setQuestionFullOrderByQuestionListLen(questionListLen, questionInfo.parentOrder, questionInfo.order);
	}, [examOrderAndQuestionsLengthMap, questionInfo.parentOrder, questionInfo.order]);

	// const currentQuestionHTML = React.useMemo(() => {
	// 	return setQuestionHTMLWithOrderAndScore(questionInfo.question, questionInfo.score, questionInfo.reference, currentOrder);
	// }, [questionInfo, questionInfo.question, questionInfo.score, questionInfo.reference, currentOrder]);
	const currentQuestionHTML = useCurrentQuestionHTML(projectExamStore, questionInfo, currentOrder, true);

	return (
		<>
			<Box className={classes.compareContent}>
				{/*<Box className={classes.compareRound}>*/}
				<div style={{ overflow: "hidden" }}>
					<Box className={classes.questionViewer}>
						<TextViewer
							currentHTML={currentQuestionHTML}
						/>
					</Box>
				</div>

				<Box className={classes.answerGuideText}>
					<Typography>
						{questionInfo.answer.answer}
					</Typography>
				</Box>
				{/*</Box>*/}
			</Box>

		</>
	);
};
